import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentReleasesService {
  releaseStatusUpdates: Subject<any> = new Subject();
  validationStatusUpdates: Subject<boolean> = new Subject<boolean>();
  activeReleaseStatusUpdates: Subject<any> = new Subject<any>();

  constructor() {}

  notifyReleaseStatusUpdates({ clusterInfo }) {
    this.releaseStatusUpdates.next({ clusterInfo });
  }

  updateValidationCount(data) {
    this.validationStatusUpdates.next(data);
  }

  refreshActiveReleaseStatus() {
    this.activeReleaseStatusUpdates.next(true);
  }
}
